<template>
  <section
    ref="bid_section"
    :class="{ active: isCartActive }"
    class="bid_section"
  >
    <div v-if="!showSuccessMessage" class="bid_container">
      <button class="cross_button" @click="closeCart">
        <img src="@/assets/img/icon/x.svg" class="cross_button_img" />
      </button>
      <div class="bid_text_form">
        <p class="title_bid_form">
          Оставьте заявку <span class="color_orange">на расчет</span>
        </p>
        <!-- <p class="sub_text_bid_form">
          Или запишитесь на встречу с нашим замерщиком. Приедет в ближайшее
          время, проконсультирует по всем вопросам!
        </p> -->
      </div>
      <div class="container_button_form" v-if="!hideCategoriesBlock">
        <div class="box_text_button_form">
          <p class="sub_text_button_form">Выберите желаемые категории мебели</p>
        </div>
        <div class="box_button_form">
          <button
            v-for="category in categories"
            :key="category"
            @click="toggleCategory(category)"
            :class="{ active: preferredContact.includes(category) }"
            class="button_form"
          >
            {{ category }}
          </button>
        </div>
      </div>
      <div class="container_input_form">
        <div class="box_name_tel">
          <div class="form-group">
            <input
              type="text"
              placeholder="Имя*"
              :class="{ error_input: errors.name }"
              v-model="orderDetails.name"
              @blur="validateName"
              @keypress="filterName"
              required
              class="input_form_order"
              @input="clearError('name')"
            />
            <span v-if="errors.name" class="error">{{ errors.name }}</span>
          </div>

          <div class="form-group">
            <input
              type="tel"
              placeholder="+7(999)-999-99-99"
              :class="{ error_input: errors.phone }"
              v-model="orderDetails.phone"
              @keypress="filterPhone"
              @input="handlePhoneInput($event)"
              @blur="validatePhone"
              class="input_form_order"
            />

            <span v-if="errors.phone" class="error">{{ errors.phone }}</span>
          </div>
        </div>
        <button class="order_form_button" @click="submitOrder">
          <span>ОТПРАВИТЬ</span>
        </button>
        <p class="text_policy_confidentiality">
          Нажимая кнопку, Вы соглашаетесь с
          <span class="text_policy_confidentiality_underline"
            >Политикой конфиденциальности</span
          >
        </p>
      </div>
    </div>
    <div v-if="showSuccessMessage" class="success_modal">
      <button class="cross_button" @click="closeCart">
        <img src="@/assets/img/icon/x.svg" class="cross_button_img" />
      </button>
      <p class="title_bid_form">
        <span class="color_orange">Спасибо </span>за заявку!
      </p>
    </div>
  </section>
</template>
<script>
import { useCartStore } from "@/store/cartStore";
import { computed, watch, nextTick } from "vue";
export default {
  data() {
    return {
      categories: [
        "Кухни",
        "Гардеробные",
        "Шкафы",
        "Прихожие",
        // "Гостиные",
        // "Детские",
        "Для бизнеса",
      ],
      showOrderForm: false,
      showOrderSuccessModal: false,
      showSuccessMessage: false,
      orderDetails: {
        name: "",
        phone: "",
      },
      preferredContact: [],
      errors: {},
    };
  },
  setup() {
    const cartStore = useCartStore();

    // ✅ Используем computed напрямую, так как `cartStore.selectedOptions` уже ref
    const selectedOptions = computed(() => cartStore.selectedOptions);

    // ✅ Следим за изменением `isCartActive`, чтобы убедиться, что данные обновляются
    watch(
      () => cartStore.isCartActive,
      async (newValue) => {
        if (newValue) {
          await nextTick(); // ⏳ Ждём, пока Pinia обновит данные
          console.log(
            "Обновленные параметры в BidForm.vue:",
            selectedOptions.value
          );
        }
      }
    );

    return {
      isCartActive: computed(() => cartStore.isCartActive),
      selectedOptions, // ✅ Теперь это реактивный объект
      hideCategoriesBlock: computed(() => cartStore.hideCategoriesBlock),
      toggleCart: cartStore.toggleCart,
      closeCart: cartStore.closeCart,
    };
  },
  methods: {
    toggleCategory(category) {
      if (this.preferredContact.includes(category)) {
        this.preferredContact = this.preferredContact.filter(
          (c) => c !== category
        );
      } else {
        this.preferredContact.push(category);
      }
    },
    handleCloseButton() {
      if (this.showOrderSuccessModal) {
        this.closeOrderSuccessModal();
      } else if (this.showOrderForm) {
        this.showOrderForm = false;
      } else {
        this.closeCart(); // 🟢 cartStore.closeCart уже включает сброс hideCategoriesBlock
      }
    },
    handlePhoneInput(event) {
      this.formatPhone(event); // Форматируем номер телефона
      this.clearError("phone"); // Убираем ошибку, если она была
    },
    clearError(field) {
      if (this.errors[field]) {
        delete this.errors[field];
      }
    },
    closeOrderSuccessModal() {
      this.showOrderSuccessModal = false; // Закрываем модальное окно
    },
    filterName(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const allowedRegex = /^[a-zA-Z\u0400-\u04FF\s]*$/;
      if (!char.match(allowedRegex)) {
        event.preventDefault();
      }
    },
    validateName() {
      const nameRegex = /^[a-zA-Z\u0400-\u04FF\s]*$/;
      if (!this.orderDetails.name) {
        this.errors.name = "Обязательное поле";
      } else if (this.orderDetails.name.length < 2) {
        this.errors.name = "Минимум 2 символа.";
      } else if (!this.orderDetails.name.match(nameRegex)) {
        this.errors.name = "Имя может содержать только буквы.";
      } else {
        delete this.errors.name; // Удаляем ошибку, если валидация пройдена
      }
    },
    filterPhone(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const allowedRegex = /^[\d+]*$/; // Разрешаем только цифры и знак "+"

      // Разрешаем удаление символов (Backspace/Delete)
      if (event.key === "Backspace" || event.key === "Delete") {
        return;
      }

      const digitsCount = this.orderDetails.phone.replace(/[^0-9]/g, "").length;
      if (!char.match(allowedRegex) || digitsCount >= 11) {
        event.preventDefault(); // Запрещаем ввод
      }
    },

    formatPhone(event) {
      // Проверяем, была ли нажата клавиша Backspace
      if (event && event.inputType === "deleteContentBackward") {
        return; // Не применяем форматирование, если происходит удаление
      }

      // Удаляем все символы, кроме цифр и "+"
      let cleaned = this.orderDetails.phone.replace(/[^0-9+]/g, "");

      // Проверяем, если поле полностью очищено, останавливаем обработку
      if (cleaned === "") {
        this.orderDetails.phone = "";
        return;
      }

      // Ограничиваем количество цифр до 11
      if (cleaned.startsWith("+7")) {
        cleaned = "+7" + cleaned.slice(2, 12); // Для номера, начинающегося с +7
      } else if (cleaned.startsWith("8")) {
        cleaned = "8" + cleaned.slice(1, 11); // Для номера, начинающегося с 8
      } else if (cleaned.startsWith("7")) {
        cleaned = "+7" + cleaned.slice(1, 11); // Для номера, начинающегося с 7
      }

      // Применяем форматирование только если длина больше 3 символов
      if (cleaned.startsWith("+7")) {
        cleaned = cleaned
          .replace(/^(\+7)(\d{0,3})/, "$1($2") // +7(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // +7(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // +7(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // +7(XXX) YYY-ZZ-WW
      } else if (cleaned.startsWith("8")) {
        cleaned = cleaned
          .replace(/^(8)(\d{0,3})/, "$1($2") // 8(XXX
          .replace(/(\(\d{3})/, (match, p1) => {
            return cleaned.length > 4 ? `${p1}) ` : p1; // Добавляем `)` и пробел
          })
          .replace(/(\)\s\d{0,3})/, "$1") // 8(XXX) YYY
          .replace(/(\s\d{3})(\d{0,2})/, "$1-$2") // 8(XXX) YYY-ZZ
          .replace(/(-\d{2})(\d{0,2})/, "$1-$2"); // 8(XXX) YYY-ZZ-WW
      }

      // Обновляем значение номера
      this.orderDetails.phone = cleaned;
    },

    validatePhone() {
      const phoneRegex = /^(\+7|8)\(\d{3}\) \d{3}-\d{2}-\d{2}$/; // Проверяем правильный формат
      if (!this.orderDetails.phone) {
        this.errors.phone = "Обязательное поле";
      } else if (!this.orderDetails.phone.match(phoneRegex)) {
        this.errors.phone = "Введите корректный номер";
      } else {
        delete this.errors.phone; // Удаляем ошибку, если валидация пройдена
      }
    },
    validateForm() {
      this.validateName();
      this.validatePhone();
      return Object.keys(this.errors).length === 0;
    },
    submitOrder() {
      if (this.validateForm()) {
        console.log(
          "Выбранные категории:",
          this.preferredContact.length > 0
            ? this.preferredContact
            : "Не выбраны"
        );
        console.log("Имя:", this.orderDetails.name);
        console.log("Телефон:", this.orderDetails.phone);
        console.log("Выбранные параметры:", this.preferredContact);
        this.showSuccessMessage = true;
        this.sendOrder();
      }
    },
    sendOrder() {
      return fetch("/api/sendOrder", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          name: this.orderDetails.name,
          phone: this.orderDetails.phone,
          preferredContact: this.preferredContact
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          this.orderNumber = data.orderNumber;
          return data;
        });
    },
  },
};
</script>
<style scoped>
.bid_section {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 3;
  width: 0%;
  height: 0vh;
  backdrop-filter: blur(2.5rem);
  background: rgba(16, 13, 10, 0.1);
  transition: 0.2s ease;
  overflow: hidden;
}

.bid_section.active {
  overflow: hidden;
  width: 100%;
  height: 100vh;
  transition: 0.2s ease;
}
.bid_container {
  height: 100%;
  width: 36.65rem;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10rem 5.6rem 10rem 5.6rem;
  gap: 3.4rem;
  justify-content: center;
}
.success_modal {
  height: 100%;
  width: 36.65rem;
  margin: 0 auto;
  background: rgb(255, 255, 255);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10rem 5.6rem 10rem 5.6rem;
  gap: 3.4rem;
}
.title_bid_form {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 1.5%;
  text-align: left;
  text-transform: uppercase;
}

.sub_text_bid_form {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: 1.5%;
  text-align: left;
}
.bid_text_form {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
.sub_text_button_form {
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
}
.box_text_button_form {
  width: 100%;
  border-bottom: 0.05rem solid rgb(51, 47, 47);
}
.box_button_form {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.button_form {
  width: fit-content;
  padding: 0px 1rem;
  height: 1.8rem;
  box-sizing: border-box;
  border: 0.05rem solid rgb(51, 47, 47);
  border-radius: 0.95rem;
  background: rgb(255, 255, 255);
  color: rgb(51, 47, 47);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  transition: 0.2s ease;
}
.container_button_form {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.container_input_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.input_form_order {
  color: rgb(51, 47, 47);
  border-bottom: 0.05rem solid rgb(51, 47, 47);
}
.box_name_tel {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.order_form_button {
  width: 100%;
  height: 3rem;
  border-radius: 4rem;
  /* 2 */
  background: linear-gradient(
    90deg,
    rgb(245, 160, 62),
    rgb(207, 117, 14) 102.477%
  );
  color: rgb(255, 255, 255);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: 0%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}
.order_form_button::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 204, 102, 0) 0%,
    rgba(255, 204, 102, 0.9) 50%,
    rgba(255, 204, 102, 0) 100%
  );
  filter: blur(4px);
  animation: wave 2s infinite linear;
  z-index: 0;
}

.order_form_button span {
  color: rgb(255, 255, 255);
  position: relative;
  z-index: 1;
}
.text_policy_confidentiality,
.text_policy_confidentiality_underline {
  color: rgb(51, 47, 47);
  letter-spacing: -0.02rem;
}
.button_form.active {
  border: 0.05rem solid rgb(245, 160, 62);
  color: rgb(245, 160, 62);
  transition: 0.2s ease;
}
.cross_button_img {
  width: 1.55rem;
  height: 1.55rem;
}
.cross_button {
  position: absolute;
  top: 3rem;
  right: 3rem;
}
@media (max-width: 767px) {
  .bid_container {
    padding: 4.7rem 1.4rem 4.7rem 1.4rem;
    width: 100%;
    height: calc(100% - 7.1rem);
    margin: 3.5rem 0px;
    gap: 2rem;
  }
  .title_bid_form {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .sub_text_bid_form {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .sub_text_button_form {
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
  }
  .button_form {
    height: 2.14rem;
    border-radius: 1.36rem;
    padding: 0px 1.7rem;
    font-size: 0.71rem;
    font-weight: 700;
    line-height: 0.86rem;
  }
  .box_button_form {
    gap: 0.7rem;
  }
  .text_policy_confidentiality {
    font-size: 0.71rem;
    font-weight: 400;
    line-height: 0.86rem;
  }
  .container_input_form {
    gap: 0.5rem;
  }
  .cross_button {
    top: 2rem;
    right: 2rem;
  }
  .success_modal {
    padding: 4.7rem 1.4rem 4.7rem 1.4rem;
    width: 100%;
    height: calc(100% - 7.1rem);
    margin: 3.5rem 0px;
    gap: 2rem;
  }
}
</style>





